import { BaseRequest } from '../request/base.request';
import { VersionPlataforma } from '../request/cash-out-request';

export class CreatePaymentRequest extends BaseRequest {
  public idMedioPago: number;
  public idPaymentRequest: number;
  public idTipoMedioPago: number;
  public titularNombre: string;
  public titularDocumento: number;
  public titularMail: string;
  public montoIngresable: string;
  public cvu?: string;
  public versionPlataforma: VersionPlataforma;
  public pagoAnonimo: boolean;

  constructor() {
    super();
    this.versionPlataforma = new VersionPlataforma();
  }
}
